import { EmptyStatePlaceholder } from '@dreryk/react-components';

import { medicalInformationTranslationKeys } from '../../../../translations';

import { AddMedicalInformationLink } from './AddMedicalInformationLink';

type MedicalInformationTableEmptyStatePlaceholderProps = {
   readonly patientId: number;
   readonly visitId: number;
};

export const MedicalInformationTableEmptyStatePlaceholder = (
   props: MedicalInformationTableEmptyStatePlaceholderProps
): JSX.Element => {
   return (
      <EmptyStatePlaceholder
         heading={medicalInformationTranslationKeys.emptyStatePlaceholder.heading}
         testId={'noMedicalInformation'}
         subheading={medicalInformationTranslationKeys.emptyStatePlaceholder.subheading}
         bottomElement={<AddMedicalInformationLink patientId={props.patientId} visitId={props.visitId} />}
      />
   );
};
